import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import affiliateMappings from './affiliateMappings';
import addressSettings from './addressSettings';
import appConfig from './appConfig';
import auth from './auth';
import banks from './banks';
import bankCaseStates from './bankCaseStates';
import bobForms from './bobForms';
import bookQuery from './bookQuery';
import cancellationReasons from './cancellationReasons';
import currencySetting from './currencySetting';
import customOptions from './customOptions';
import fetchM from './fetchM';
import financeSources from './financeSources';
import flash from './flash';
import globalSettings from './globalSettings';
import himsDistricts from './himsDistricts';
import himsPostcodes from './himsPostcodes';
import identityPresets from './identityPresets';
import network from './network';
import phoneValidationPresets from './phoneValidationPresets';
import projectBusinessUnits from './projectBusinessUnits';
import projectMappings from './projectMappings';
import projectOptions from './projectOptions';
import projectSpecifications from './projectSpecifications';
import projectUnitLayoutSpecifications from './projectUnitLayoutSpecifications';
import projectUnitSpecifications from './projectUnitSpecifications';
import prompt from './prompt';
import salesChartTypes from './salesChartTypes';
import tags from './tags';
import templates from './templates';

export default combineReducers({
  routing: routerReducer,

  affiliateMappings,
  addressSettings,
  appConfig,
  auth,
  banks,
  bankCaseStates,
  bobForms,
  bookQuery,
  cancellationReasons,
  currencySetting,
  customOptions,
  fetchM,
  financeSources,
  flash,
  globalSettings,
  himsDistricts,
  himsPostcodes,
  identityPresets,
  phoneValidationPresets,
  network,
  projectBusinessUnits,
  projectMappings,
  projectOptions,
  projectSpecifications,
  projectUnitLayoutSpecifications,
  projectUnitSpecifications,
  prompt,
  salesChartTypes,
  tags,
  templates,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js